import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { STATE_ORDER, STATE_LABELS } from "@/lib/states";
import { Settings } from "lucide-react";

export default function StateControl({ kind, id, state, enrollOverride, isAdmin, onChanged }) {
  const [saving, setSaving] = useState(false);

  const setState = async (s) => {
    setSaving(true);
    try {
      await api.put(`/${kind}/${id}/state`, { state: s });
      toast.success("Stato aggiornato");
      onChanged && onChanged();
    } catch {
      toast.error("Errore nel cambio stato");
    } finally {
      setSaving(false);
    }
  };

  const toggleOverride = async (e) => {
    const enabled = e.target.checked;
    try {
      await api.put(`/${kind}/${id}/enroll-override`, { enabled });
      toast.success(enabled ? "Iscrizioni sbloccate" : "Iscrizioni ripristinate");
      onChanged && onChanged();
    } catch {
      toast.error("Errore");
    }
  };

  return (
    <div data-testid="state-control" className="border border-cyan-500/30 bg-cyan-500/5 p-4 rounded-lg space-y-3">
      <div className="flex items-center gap-2 text-[10px] font-bold tracking-[0.2em] uppercase text-cyan-400">
        <Settings className="h-3.5 w-3.5" /> Gestione stato
      </div>
      <div className="flex flex-wrap gap-2">
        {STATE_ORDER.map((s) => (
          <button key={s} disabled={saving} data-testid={`set-state-${s}`} onClick={() => setState(s)}
            className={`px-3 py-2 text-xs font-bold uppercase tracking-wider border transition-colors duration-200 ${
              state === s ? "border-yellow-400 bg-yellow-400/10 text-yellow-400" : "border-zinc-700 text-zinc-400 hover:border-zinc-500"
            }`}>
            {STATE_LABELS[s]}
          </button>
        ))}
      </div>
      {isAdmin && (
        <label className="flex items-center gap-2 text-xs text-zinc-300 cursor-pointer">
          <input type="checkbox" data-testid="enroll-override" defaultChecked={!!enrollOverride} onChange={toggleOverride}
            className="accent-yellow-400 h-4 w-4" />
          Consenti le iscrizioni anche quando è chiuso, in corso o terminato
        </label>
      )}
    </div>
  );
}
